
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.222 5.4h5.334a.883.883 0 00.628-.264.906.906 0 000-1.272.883.883 0 00-.628-.264H6.222a.883.883 0 00-.628.264.906.906 0 000 1.272.883.883 0 00.628.264zM4.444 9h7.112a.883.883 0 00.628-.264.906.906 0 000-1.272.883.883 0 00-.628-.264H4.444a.883.883 0 00-.628.264.906.906 0 000 1.272.883.883 0 00.628.264zm0 3.6h7.112a.883.883 0 00.628-.264.906.906 0 000-1.272.883.883 0 00-.628-.264H4.444a.883.883 0 00-.628.264.906.906 0 000 1.272.883.883 0 00.628.264zM15.111 0H.89A.883.883 0 00.26.264.906.906 0 000 .9v16.2a.909.909 0 00.491.805.88.88 0 00.931-.085l1.84-1.395 1.831 1.395a.882.882 0 001.067 0L8 16.425l1.84 1.395a.882.882 0 001.067 0l1.83-1.395 1.84 1.395a.883.883 0 001.29-.25.908.908 0 00.133-.47V.9a.906.906 0 00-.26-.636A.883.883 0 0015.11 0zm-.889 15.3l-.95-.72a.882.882 0 00-1.068 0l-1.83 1.395-1.84-1.395a.882.882 0 00-1.067 0l-1.84 1.395-1.831-1.395a.882.882 0 00-1.067 0l-.951.72V1.8h12.444v13.5z"}})])
          )
        }
      }
    